<script>
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: 'UnitChat',
  components: {NavbarPage, LoadingPage},
  setup() {

    // document.documentElement.scrollTop = document.documentElement.scrollHeight
    // window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);

    let unit_id = useRoute().params.chat_id
    // let chat_id = useRoute().params.chat_id;

    let user_name = ref(useStore().state.my_profile.full_name)
    let unit_name = ref()

    let chats = ref([])
    // let listChatRef = ref(null)
    let load_page = ref(false)

    let text_chat = ref('')

    let chats_count = 0
    let update = ref(1)
    let check_send = ref(false)

    function load_chats() {
      let data = {
        unit_id: unit_id,
        typeUser: 'user',
        action: 'show',
      }
      // load_page.value = true
      FreeWorld.Heisenberg(data, 'unit/chats', true).then((result) => {

        load_page.value = false
        var res = result.data
        chats.value = res.chats
        unit_name.value = res.nameUser.manager_name
        if (chats.value.length != chats_count) {
          chats_count = chats.value.length
          update.value++
        }

      }).catch((result) => {
        load_page.value = false
        Swals.Catch(result, load_chats)
      })

    }

    load_chats()


    watch(() => update.value, () => {

      setTimeout(() => {
        document.documentElement.scrollTop = document.documentElement.scrollHeight
        document.getElementById('list_chats-web').scrollTop = document.getElementById('list_chats-web').scrollHeight
      }, 100)

    })


    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });


    const update_chats = ref(null)
    onMounted(() => {
      update_chats.value = setInterval(() => {
        let data = {
          unit_id: unit_id,
          typeUser: 'user',
          action: 'show',
        }
        // load_page.value = true
        FreeWorld.Heisenberg(data, 'unit/chats', true).then((result) => {

          load_page.value = false
          var res = result.data
          chats.value = res.chats
          unit_name.value = res.nameUser.manager_name
          if (chats.value.length != chats_count) {
            chats_count = chats.value.length
            update.value++
          }


        }).catch(() => {
          console.log('RefreshPage = error')
        })
      }, 1500)
    })
    onBeforeUnmount(() => {
      clearInterval(update_chats.value)
    })


    function send_chat() {
      if (text_chat.value.trim().length > 0) {

        document.getElementById('type_message').style.pointerEvents = 'none'
        check_send.value = true

        let data = {
          unit_id: unit_id,
          typeUser: 'user',
          text: text_chat.value,
          action: 'insert',
        }
        FreeWorld.Heisenberg(data, 'unit/chats', true).then(() => {

          check_send.value = false
          text_chat.value = ''
          document.getElementById('type_message').style.pointerEvents = 'auto'
          load_chats()

        }).catch((result) => {
          check_send.value = false
          document.getElementById('type_message').style.pointerEvents = 'auto'
          Swals.Catch(result, send_chat)
        })

      } else {
        text_chat.value = ''
      }
    }


    return {

      load_page,
      chats,
      user_name,
      send_chat,
      unit_name,
      text_chat,
      check_send,

    }
  }
}
</script>

<template>
  <LoadingPage v-if="load_page"></LoadingPage>

  <div dir="ltr" id="main" :class="load_page ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center justify-content-end">
      <p class="m-0 d-flex font-4">
         <span>
          {{ unit_name }}
        </span>
        &nbsp;
        <span>
          چت با
        </span>
      </p>
      <div onclick="history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div v-if="chats.length != 0 " class="list_chat py-2 max_width p-body mb-3" id="list_chats">
      <div class="animate__animated animate__bounceInUp" v-for="item in chats" :key="item.id">
        <!-- ***چت های فروشنده در این دیو قرار گیرد***-->
        <div :style="{ direction: item.type_user === 'user' ? 'rtl' : 'ltr'}" class="p-body">
          <div
              :style="{ direction: item.type_user === 'user' ? 'ltr' : 'unset' , backgroundColor: item.type_user === 'user' ? 'wheat':'white' }"
              class="chat_user shadow-costom">
            <p v-if="item.type_user === 'user'" class="font-4 text-end font-bold fw-bold"
               :class="{'txtoverflow':user_name.length > 35}">{{ user_name }}</p>
            <p v-else class="font-4 text-end font-bold fw-bold" :class="{'txtoverflow':unit_name.length > 35}">
              {{ unit_name }}</p>
            <p class="font-4 text-end">{{ item.text }}</p>
            <p class="m-0 font-4 d-flex">
              <span class="mx-3">{{ item.date }}</span>
              <span>{{ item.time }}</span>
            </p>
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>
      <br>
    </div>

    <div id="type_message" class="type_message max_width p-body">
      <div class="p-2 bg-white d-flex align-items-center justify-content-between border-color-red rounded-4">
       <textarea v-if="!check_send" v-model="text_chat" class="input_send_message border-none p-1 w-100" type="text"
                 placeholder="پیام جدید بنویسید..."></textarea>
        <p v-else dir="rtl" class="input_send_message border-none p-2 w-100">درحال ارسال...</p>
        <img @click="send_chat" class="icon_send_message rounded-pill" src="../assets/img/send-message-icon.jpg" alt="">
      </div>
    </div>

  </div>

  <div id="web" :class="load_page ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">گفتگو با
      {{ unit_name }}
    </div>

    <div class="w-75 bg-white ma-auto rounded-4 p-3">
      <div v-if="chats.length != 0 " class="list_chat-web position-relative" id="list_chats-web">
        <div class="animate__animated animate__bounce" v-for="item in chats" :key="item.id">
          <!-- ***چت های فروشنده در این دیو قرار گیرد***-->
          <div :style="{ direction: item.type_user === 'user' ? 'rtl' : 'ltr'}" class="p-body">
            <div
                :style="{ direction: item.type_user === 'user' ? 'ltr' : 'unset' , backgroundColor: item.type_user === 'user' ? 'wheat':'white' }"
                class="chat_user shadow-costom" >
              <p v-if="item.type_user === 'user'" class="font-4 text-end font-bold fw-bold"
                 :class="{'txtoverflow':user_name.length > 35}">{{ user_name }}</p>
              <p v-else class="font-4 text-end font-bold fw-bold" :class="{'txtoverflow':unit_name.length > 35}">
                {{ unit_name }}</p>
              <p class="font-3 text-end">{{ item.text }}</p>
              <p class="m-0 font-4 d-flex">
                <span class="mx-3">{{ item.date }}</span>
                <span>{{ item.time }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="type_message" class="position-fixed" style="bottom: 5%;width: 48.5%">
        <div class="p-2 bg-white d-flex align-items-center justify-content-between border-color-red rounded-4">
          <img @click="send_chat" class="icon_send_message rounded-pill" src="../assets/img/send-message-icon.jpg"
               alt="">
          <textarea v-if="!check_send" v-model="text_chat" class="input_send_message border-none p-1 w-100" type="text"
                    placeholder="پیام جدید بنویسید..."></textarea>
          <p v-else dir="rtl" class="input_send_message border-none p-2 w-100">درحال ارسال...</p>
        </div>
      </div>

    </div>

  </div>

</template>

<style scoped>

.list_chat {
  min-height: 83vh;
  scroll-behavior: smooth;
  width: 100%;
}

.list_chat-web {
  height: 33rem;
  overflow-y: scroll;
}

.list_chat-web::-webkit-scrollbar {
  display: none;
}

.chat_user {
  border-radius: 15px;
  max-width: 65%;
  margin-bottom: 20px;
  padding: 10px;
  overflow: hidden;
}

.type_message {
  position: fixed;
  bottom: 10px;
  width: 100%;
}

.icon_send_message {
  width: 50px;
  height: 50px;
}

.input_send_message {
  box-sizing: border-box;
  resize: none;
  font-size: 16px;
  outline: none;
  max-height: 200px !important;
}

</style>